import { SET_HIGHLIGHTED_ATTRS_CONFIG } from '../actions/types';

export default function highlightedAttrsConfig(state = [], action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_HIGHLIGHTED_ATTRS_CONFIG:
				return action.payload;

			// no default
		}
	}

	return state;
}
